// extracted by mini-css-extract-plugin
export default {"navbar":"Layout_navbar__MyxAy","dashboard":"Layout_dashboard__y2zh4","mainContent":"Layout_mainContent__6OoEY","noScroll":"Layout_noScroll__FGKql","footer":"Layout_footer__eJwb-"};